import React, { useState } from "react";
const SearchBarInbuilt = (props) => {
    const [openSearch, setOpenSearch] = useState(false);
    const handleFocus = () => {
        setOpenSearch(true);
        if (props.onFocus) {
            props.onFocus();
        }
    };
    const handleBlur = () => {
        if (!(props === null || props === void 0 ? void 0 : props.searchValue)) {
            props.onCallbackFunction("");
            setOpenSearch(false);
            if (props.onBack) {
                props.onBack();
            }
        }
        if (props.onBlur) {
            props.onBlur();
        }
    };
    const handleClose = () => {
        props.onCallbackFunction("");
        setOpenSearch(false);
        if (props.onClose) {
            props.onClose();
        }
    };
    return (React.createElement("div", { className: props.parentClassName ? props.parentClassName : "" },
        React.createElement("div", { className: ` common-search  ${props.searchBarBackground} ${openSearch ? "open-search" : ""}` },
            React.createElement("input", { autoFocus: props.focusOnLoad, autoComplete: "off", disabled: props === null || props === void 0 ? void 0 : props.disabled, className: openSearch ? props.openInputBackground : props.searchBarBackground, id: "focus-input", type: "search", placeholder: props.deskPlaceHolder || "Search Name", value: props === null || props === void 0 ? void 0 : props.searchValue, onFocus: handleFocus, onChange: (e) => props.onCallbackFunction(e.target.value), onBlur: handleBlur }),
            React.createElement("label", { className: "search-icon-class" }, openSearch ? (React.createElement("i", { className: "edel-icon-close DMsanR_10_400 txt_secondary-gray hand_cursor", onClick: handleClose })) : (React.createElement("i", { className: "edel-icon-search1 DMsanR_10_400", onClick: handleFocus }))))));
};
export default SearchBarInbuilt;
